export default __webpack_public_path__ + "static/media/CleanproBackButton.b4d61dc8.png";